import { writable } from 'svelte/store';
const config = writable({ waitTime: 3000 });
export default config;